/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  FormControl,
  FormLabel,
  Input,
  useToast,
  Stack,
  HStack,
  Avatar,
  Box,
  Text,
  Spacer,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
} from '@chakra-ui/react';
import useUserStore from '../../Hooks/Zustand/Store';
import { getCollectionFirebase, updateDocumentFirebase } from '../../Api/firebaseApi';
import DynamicButton from '../Buttons/DynamicButton';
import { TypesenseRestApi } from '../../Api/TypesenseApi';

function AccessAddNewUser({ role, setRole, getUser }) {
  const globalState = useUserStore();
  const [email, setEmail] = useState('');
  const [searchResult, setSearchResult] = useState([]);
  const [otherRole, setOtherRole] = useState('');

  const searchModal = useDisclosure();
  const warningModal = useDisclosure();
  const toast = useToast();

  const handleOpen = () => {
    setEmail('');
    searchModal.onOpen();
  };

  const handleChange = (c) => {
    handleSearchUsers(c);
    setEmail(c);
  };

  const chunkArray = (arr, chunkSize) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
      chunks.push(arr.slice(i, i + chunkSize));
    }
    return chunks;
  };

  const handleSearchUsers = async (q) => {
    const projectUsers = globalState.projects.find((x) => x.id === globalState.currentProject);
    const userChunks = chunkArray(projectUsers?.users, 100);

    const searchParameters = {
      q: q,
      query_by: 'name,email',
      filter_by: `id: [${userChunks.join(',')}]`,
      sort_by: '_text_match:desc',
    };

    try {
      const response = await TypesenseRestApi({
        collection: 'users',
        ...searchParameters,
      });
      const newData = response?.hits?.map((y) => {
        return { ...y.document };
      });
      setSearchResult(newData);
    } catch (error) {
      console.error(error.message);
    }
  };

  const handleClick = async (email) => {
    try {
      if (!email) return;
      const filter1 = [{ field: 'email', operator: '==', value: email }];
      const res = await getCollectionFirebase('users', filter1);
      const uid = res?.[0]?.id;
      if (uid) {
        const idx = role?.users?.findIndex((x) => x === uid);
        if (idx > -1) {
          toast({
            title: 'User sudah ada di daftar ini',
            status: 'info',
            duration: 3000,
          });
          return;
        }
        const filter2 = [
          { field: 'users', operator: 'array-contains', value: uid },
          { field: 'title', operator: '!=', value: 'users' },
          { field: 'module', operator: '==', value: 'wms' },
          { field: 'projectId', operator: '==', value: globalState?.currentProject }
        ];
        const regRoles = await getCollectionFirebase('role_access', filter2);
        if (regRoles?.length > 0) {
          setOtherRole(regRoles?.[0]?.title);
          searchModal.onClose();
          warningModal.onOpen();
          return;
        }
        const currentUsers = JSON.parse(JSON.stringify(role?.users));
        currentUsers.push(uid);
        await updateDocumentFirebase('role_access', role?.id, { users: currentUsers, source: 'wms' });
        setRole((prev) => {
          const newRole = { ...prev };
          if (newRole?.users) newRole.users.push(uid);

          return newRole;
        });
        await getUser([uid], true);
        searchModal.onClose();
      }
    } catch (e) {
      throw new Error(e.message);
    }
  };

  return (
    <>
      <DynamicButton action="create" variant="solid" title="User" onClick={() => handleOpen()} />

      <Modal isOpen={searchModal.isOpen} onClose={searchModal.onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Tambah User</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl>
              <FormLabel>Email</FormLabel>
              <Stack pb="20px">
                <Input value={email} onChange={(e) => handleChange(e.target.value)} />
                {searchResult.map((x, index) => {
                  return (
                    <HStack key={index} p="2" borderBottom="1px">
                      <Avatar name={x?.name} src={x?.image ? x?.image : ''} />
                      <Box>
                        <Text w={'200px'} noOfLines={1}>
                          {x?.name}
                        </Text>
                        <Text w={'200px'} noOfLines={1}>
                          {x?.email}
                        </Text>
                      </Box>
                      <Spacer />
                      <Button colorScheme="green" onClick={() => handleClick(x?.email)}>
                        +
                      </Button>
                    </HStack>
                  );
                })}
              </Stack>
            </FormControl>
          </ModalBody>
        </ModalContent>
      </Modal>

      <AlertDialog isOpen={warningModal.isOpen} onClose={warningModal.onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              User sudah terdaftar di role {otherRole}
            </AlertDialogHeader>
            <AlertDialogBody>Silahkan hapus user dari role tersebut terlebih dahulu</AlertDialogBody>
            <AlertDialogFooter>
              <Button colorScheme="blue" onClick={warningModal.onClose} ml={3}>
                Tutup
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
}

export default AccessAddNewUser;
